<template>
  <div class="f-column">
    <!-- <div v-if="!masterBranch">
      DEV ONLY
      <div class="d-flex my-2">
        <PokerCard
          v-for="cs in cardSizes"
          :key="cs"
          :card="'Ah'"
          :size="cs"
          class="mr-1"
          @click="setBack(ct)"
        />
      </div>
      <div class="d-flex my-2">
        <PokerCard
          v-for="cs in cardSizes"
          :key="cs"
          :size="cs"
          class="mr-1"
          @click="setBack(ct)"
        />
      </div>
    </div> -->
    <div
      v-if="hasFront"
      class="f-column"
    >
      <GwTitleTooltip
        class="theme-block-title"
        :title="$t('settings.card_theme')"
        :tooltip="$t('tooltips.card_theme')"
      />
      <div class="d-flex mb-2">
        <GwBtns
          :options="[
            {
              id: 'default',
              text: $t('common.colored'),
              fn: () => {
                setTheme(cardVisual.cardTheme.replace('inverted', 'default'))
              },
            },
            {
              id: 'inverted',
              text: $t('common.blank'),
              fn: () => {
                setTheme(cardVisual.cardTheme.replace('default', 'inverted'))
              },
            },
          ]"
          :value="cardVisual.cardTheme.includes('inverted') ? 'inverted' : 'default'"
          idKey="id"
          class="gwbtns_horizontal_grey"
          style="
            background: var(--clr-black-1-3);
            border-radius: 4px;
            --gwbtn-size: 1rem;
            --gwbtn-height: 1.875rem;
            --gwbtns-wrap: wrap;
            --gwbtns-padding: 2px;
          "
          @click="
            (_e, item) => {
              item.fn()
            }
          "
        >
          <template #default="{ item }">
            {{ item.text }}
          </template>
        </GwBtns>
      </div>
      <div class="settings-cards-style settcrds">
        <PokerCard
          v-for="ct in l_cardThemes"
          :key="ct"
          :hasTheme="false"
          class="poker-card_selectable settcrds_card"
          :customCardTheme="ct"
          :class="{ 'card-style-active': cardVisual.cardTheme === ct }"
          :card="'Ad'"
          size="large"
          @click="setTheme(ct)"
        />
      </div>
    </div>
    <div
      v-if="hasBack"
      :class="{ 'mt-4': hasFront }"
    >
      <GwTitleTooltip
        class="theme-block-title"
        :title="$t('settings.card_back_theme')"
        :tooltip="$t('tooltips.card_back_theme')"
      />
      <SettingsColors
        :colorList="suitsColors"
        :enabledColors="['card_back']"
      />
      <div class="settings-cards-style settcrds mt-2">
        <PokerCard
          v-for="ct in cardBacks"
          :key="ct"
          :hasTheme="false"
          class="poker-card_selectable poker-card_clickable settcrds_card"
          :customCardBack="ct"
          :class="{ 'card-style-active': cardVisual.cardBack === ct }"
          size="large"
          @click="setBack(ct)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import GwBtns from '@/components/lib/GwBtns'
import SettingsColors from '@/components/Dialogs/UserSettingsDialog/SettingsColors'
import GwTitleTooltip from '@/components/Dialogs/UserSettingsDialog/GwTitleTooltip'
import PokerCard from '@/components/Poker/PokerCard/PokerCard'

export default {
  name: 'SettingsCardsStyle',
  // #2A75A5,#5ab966,#129683,#888787, #CB0303, #FFFC6B,#00C925, #f55353,#04B8A9, #B8B404, #ECBC25, #EC7925, #C24E03, #C20303, #C72121, #A521C7,#0481C0,#424242,#258337,#8b0901,#00ac8d,#23b5ef,#1e1e1e,#1e1e1e, #f5f5f5,#121212, #f5f5f5, #cfcfcf,#1e1e1e,#2f2f2f, #FFFFFF01,#00000000,#00000000,#3f3f3fFF,#12121200,#00000000,#00000000,#262626FF,#00ac8d, #ff8f00,#3f3f3f,#262626,#1e1e1e8F; 2, 2, 2, 22, 2, 2
  components: {
    PokerCard,
    GwBtns,
    SettingsColors,
    GwTitleTooltip,
  },
  props: {
    hasTitle: { type: Boolean, default: true },
    hasFront: { type: Boolean, default: true },
    hasBack: { type: Boolean, default: true },
  },
  data() {
    this.masterBranch = import.meta.env.VITE_BRANCH === 'master'
    this.cardSizes = ['mini', 'smallest', 'smaller', 'small', 'medium', 'large']
    this.cardThemes = [
      'default_plain',
      'default',
      'default_thick',
      'default_big_symbol',
      'default_big_symbol2',
      'default_thick2',
      'default_downsymbol',
      'default_fancy',

      'inverted_plain',
      'inverted',
      'inverted_thick',
      'inverted_big_symbol',
      'inverted_big_symbol2',
      'inverted_thick2',
      'inverted_downsymbol',
      'inverted_fancy',
    ]
    this.cardBacks = [
      'back_plain',
      'back_rectangles',
      'back_zigzag',
      'back_isometric',
      'back_triangle',
      'back_rhombus',
      'back_diagonal',
      'back_logo',
    ]
    return {
      card: {
        value: 'A',
        color: 'hearts',
        colorCode: 'h',
        placement: 'cardPack',
      },
    }
  },
  methods: {
    setTheme(val) {
      // console.log(val)
      this.$store.dispatch('userSettings', { cardTheme: val })
    },
    setBack(val) {
      this.$store.dispatch('userSettings', { cardBack: val })
    },
    reset() {
      this.setTheme('default')
    },
  },
  computed: {
    l_cardThemes() {
      const inverted = this.cardVisual.cardTheme.includes('inverted')
      return this.cardThemes.filter(ct =>
        inverted ? ct.includes('inverted') : ct.includes('default'),
      )
    },
    suitsColors() {
      return this.$store.getters.mergedUserSettings.suitsColors
    },
    cardVisual() {
      const { cardTheme, cardBack } = this.$store.getters.mergedUserSettings
      return {
        cardTheme,
        cardBack,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.settcrds {
  display: grid;
  grid-template-columns: repeat(8, auto);
  grid-gap: 0.25rem;
  width: 11rem;
  &_card {
    margin: 0 !important;
  }
}
.card-style-active {
  box-shadow: 0 0 0 2px var(--clr-primary);
}
</style>
